<div class="item-inner text-center">
    <strong [i18n]="'bma.functionalityDisabled'"></strong>
</div>
